<!-- Show mat-select with infinite scroll if isSelectable is true -->
<div *ngIf="isSelectable; else projectList">
  <mat-form-field appearance="outline" class="w-full overflow-hidden">
    <mat-label>{{ 'Select Projects' | transloco }}</mat-label>
    <mat-select multiple [(value)]="selectedProjects" (selectionChange)="onSelectionChange()">
      <div
        infiniteScroll
        [scrollWindow]="false"
        [infiniteScrollDisabled]="loading"
        (scrolled)="onScroll()"
        class="list-container"
        *ngIf="!loading && list.length"
      >
        <span class="text-sm text-primary">{{ 'L' + item.level }}</span>
        <mat-icon
          [svgIcon]="
            transloco.getActiveLang() === 'en' || transloco.getActiveLang() === 'ru'
              ? 'mat_solid:arrow_right'
              : 'mat_solid:arrow_left'
          "
          class="flex items-center icon-size-2"
        ></mat-icon>

        {{ item.project_name | truncate: 30 | titlecase }}
      </div>
    </mat-select>
  </mat-form-field>
</div>

<!-- Regular list view when not in selectable mode -->
<ng-template #projectList>
  <div
    infiniteScroll
    [scrollWindow]="false"
    [infiniteScrollDisabled]="loading"
    (scrolled)="onScroll()"
    class="list-container"
    *ngIf="!loading && list.length"
  >
    <div
      *ngFor="let item of list"
      class="flex flex-row items-center w-full max-h-100 border-b-2 border-accent-600 bg-accent-900 p-2 rounded-md"
    >
      <div class="flex flex-row w-full justify-between">
        <div
          class="flex flex-row items-center"
          matTooltipPosition="above"
          [matTooltip]="item.project_name | titlecase"
        >
          <span class="text-sm text-primary">{{ 'L' + item.level }}</span>
          <mat-icon
            [svgIcon]="
              transloco.getActiveLang() === 'en' || transloco.getActiveLang() === 'ru'
                ? 'mat_solid:arrow_right'
                : 'mat_solid:arrow_left'
            "
            class="flex items-center icon-size-2"
          ></mat-icon>

          {{ item.project_name | truncate: 30 | titlecase }}
        </div>

        <div
          matTooltipPosition="above"
          [matTooltip]="'User Role' | transloco"
          class="flex flex-row items-center text-secondary"
        >
          ({{ item.project_user_role | removeUnderscore | titlecase | transloco }})
          <a
            mat-icon-button
            target="_blank"
            [href]="environment.base_url + '/project-d/' + item.id"
          >
            <mat-icon
              class="icon-size-4"
              svgIcon="mat_solid:open_in_new"
              [matTooltip]="'Open in new tab' | transloco"
              matTooltipPosition="above"
            ></mat-icon>
          </a>
        </div>
      </div>
    </div>

    <div *ngIf="loading" class="loading-spinner">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
  </div>
</ng-template>

<div *ngIf="!list.length && !loading" class="flex flex-row w-full justify-center">
  <app-error-template
    [type]="'empty'"
    [bodyMessage]="'No Shared Projects' | transloco"
  ></app-error-template>
</div>
